module.exports = __webpack_public_path__ + "7844ef4cdc7f690b2eeb2804955f498d.fbx";